import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonSelect, IonSelectOption, IonSpinner } from "@ionic/react";
import React from "react";
import { InputFactory } from "../Factories/Input";

export default class Select extends React.Component<any, any> {
  render() {
    const { type, value, options, ...disabledFieldProps } = this.props;
    const disabledValue = this.props.disabled && options && Object.keys(options).length && options[value] ? options[value] : "-";
    return this.props.disabled ? (
      <InputFactory type="text" value={disabledValue} className="collapse-form__field-value" placeholder="―" disabled {...disabledFieldProps} />
    ) : (
      <div>
        <FontAwesomeIcon icon={faChevronDown} />
        <IonSelect interface="action-sheet" interfaceOptions={{ className: "action-sheet--no-cancel" }} {...this.props}>
          {options && Object.keys(options).length ? (
            Object.keys(options).map((option, key) => (
              <IonSelectOption value={option} key={key}>
                {options[option]}
              </IonSelectOption>
            ))
          ) : (
            <IonSelectOption>
              <IonSpinner name="dots" />
            </IonSelectOption>
          )}
        </IonSelect>
      </div>
    );
  }
}
